import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { get, post } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { UNFREEZ_ORDER, FREE_ORDER } from "helpers/api_endpoints";

const ModOrder = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const type = params.type;
    console.log('test', id, type);
    const navigate = useNavigate();

    useEffect(() => {
        if(type == 'unfreeze')
            get(`${UNFREEZ_ORDER}/${id}`)
                .then(response => {
                    navigate('/orders', { state: { successMsg: 'Unfreezed SuccessFully' } });
                })
                .catch(error => {
                    console.log(error);
                })
        else if(type == 'unassign')
            post(FREE_ORDER, { orderId: id })
                .then(response => {
                    navigate('/orders', { state: { successMsg: 'Unassigned SuccessFully' } });
                })
                .catch(error => {
                    console.log(error);
                })
    },[]);

    return <React.Fragment>Removed</React.Fragment>;
};

export default withRouter(ModOrder);